import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-references',
  templateUrl: './skeleton-references.component.html',
  styleUrls: ['./skeleton-references.component.scss'],
  standalone: false,
})
export class HelpAndSupportSkeletonComponent {
  helpAndSupportData: any[] | null = null;
}
